import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const MapContainer = styled.div`
    width: 750px;
    height: 450px;
`;

export const CPMapContainer = styled.div`
    width: 750px;
    height: 450px;
`;

export const CPAraucariaMapContainer = styled.div`
    width: 600px;
    height: 500px;
`;

export const CPFullMapContainer = styled.div`
    width: 1000px;
    height: 600px;
`;
